module.exports = __webpack_public_path__ + "static/media/logo-rennes-black.85bac4de.svg";